<template>
  <div>
    <note :type="product.status === 'error' ? 'danger' : 'warning'" v-if="product.message" v-html="productStatusMessage"></note>

    <note :type="product.stock.status === 'error' ? 'danger' : 'warning'" v-if="product.stock.message" v-html="productStockStatusMessage"></note>

    <note :type="product.price.status === 'error' ? 'danger' : 'warning'" v-if="product.price.message" v-html="productPriceStatusMessage"></note>

    <panel title="Informações gerais do produto">
      <span slot="header-right" class="badge" :class="product.status">{{ $t(`${product.status}.label`) }}</span>

      <div class="l-row">
        <div class="l-col-12@md l-col-4@sm">
         <span class="ds-block margin">
           <strong>Título:</strong>
           {{ product.title }}
         </span>
        </div>
      </div>
      <div class="l-row">
        <div class="l-col-4@md l-col-4@sm">
         <span class="ds-block margin">
           <strong>Marca:</strong>
           {{ product.brand }}
         </span>
        </div>

        <div class="l-col-4@md l-col-4@sm">
         <span class="ds-block margin">
           <strong>EAN:</strong>
           {{ product.ean }}
         </span>
        </div>

        <div class="l-col-4@md l-col-4@sm">
         <span class="ds-block margin">
           <strong>SKU:</strong>
           {{ product.sku }}
         </span>
        </div>
      </div>

      <div class="l-row">
        <slot name="attributes"/>
      </div>
    </panel>

    <panel title="Descrição" v-if="logFilters.module_identifier === 'cnova'">
      <form-group :columns="12" label="Descrição do Produto" :error="getError('description', product.productId)" :required="true">
        <quill-editor :options="{ placeholder: 'Adicione a descrição do seu produto aqui' } " v-model="product.description" />
        <small class="form-help"></small>
      </form-group>
    </panel>

    <panel title="Prazo extra" v-if="product.crossDocking">
      <span slot="header-right" class="badge" :class="product.crossDocking.status">{{ $t(product.crossDocking.status).label }}</span>

      <form-group label="Quantidade" :columns="3">
        <input class="form-input" type="text" v-model="product.crossDocking.quantity" :disabled="true">
      </form-group>
    </panel>

    <panel title="Preço">
      <div slot="header-right">
        <button class="btn btn--sm btn--info btn-history" @click="showPriceHistory">
          <i class="icon-folder-search"></i>
          <span>Histórico</span>
        </button>
        <span class="badge" :class="product.price.status">{{ $t(product.price.status).label }}</span>
      </div>
      <div class="l-row">
        <div class="l-col-12@md">
          <product-price :input="product.price" :module="product.source" :sku="product.sku"/>
        </div>
      </div>
    </panel>

    <panel title="Dimensões" v-if="logFilters.module_identifier === 'cnova'">
      <form-group label="Altura" :columns="3" :error="getError('product.height', product.productId)">
        <input class="form-input" type="text" v-mask="'#.##'" v-model="product.height">
      </form-group>
      <form-group label="Largura" :columns="3" :error="getError('product.width', product.productId)">
        <input class="form-input" type="text" v-mask="'#.##'" v-model="product.width">
      </form-group>
      <form-group label="Profundidade" :columns="3" :error="getError('product.length', product.productId)">
        <input class="form-input" type="text" v-mask="'#.##'" v-model="product.length">
      </form-group>
    </panel>

    <slot name="before-price"/>

    <div class="l-row vertical-flex">
      <div class="l-col-8@md">
        <panel title="Estoque">
          <span slot="header-right" class="badge" :class="product.stock.status">{{ $t(product.stock.status).label }}</span>
          <div class="l-row">
            <form-group label="Quantidade" :columns="3">
              <input class="form-input" type="text" v-model="product.stock.quantity" :disabled="true">
            </form-group>
            <form-group label="Redutor" :columns="3">
              <input class="form-input" type="text" v-model="product.stock.reducer">
            </form-group>
          </div>
        </panel>

        <panel title="Imagens enviadas" v-if="images.length">
          <div>
            <gallery :images="images" :index="galleryIndex" :options="{ closeOnSlideClick: true }" @close="index = null"/>
            <div class="image-container" v-for="(image, index) in images" :key="index" @click="galleryIndex = index">
              <img :src="image"/>
            </div>
          </div>
        </panel>

        <slot name="body-bottom-left"/>
      </div>

      <div class="l-col-4@md">
        <simple-list-log :options="logFilters"/>
      </div>
    </div>

    <panel title="Atributos do produto" v-if="product.attributes.length || logFilters.module_identifier === 'webcontinental'">
      <div class="l-row">
        <div class="l-col-4@md l-col-4@sm" v-for="attribute in product.attributes" :key="attribute.code">
          <span class="ds-block margin">
            <strong>{{ attribute.label }}:</strong>
            {{ attribute.valueLabel }}
          </span>
        </div>
      </div>

      <form-group label="Garantia" :columns="3">
        <input class="form-input" type="number" v-model="product.warranty" :disabled="false">
      </form-group>
    </panel>
    </panel>

    <panel title="Atributos do produto" v-if="logFilters.module_identifier === 'zoom'">
      <div class="l-row">
        <div class="l-col-12@md l-col-12@sm">
          <form-group :label="$t(`voltage.label`)" :columns="3" :required="true">
            <select class="form-select" v-model="product.attributes['voltage']">
              <option value="none">Não se aplica</option>
              <option value="110V">110V</option>
              <option value="127V">127V</option>
              <option value="220V">220V</option>
              <option value="380V">380V</option>
              <option value="bivolt">bivolt</option>
            </select>
          </form-group>
        </div>
      </div>
    </panel>

    <modal-price-history :sku="product.sku" :module="{ 'type': 'marketplace', 'identifier': logFilters.module_identifier }" v-model="modalPriceHistory"/>
  </div>
</template>

<script>
  import { quillEditor } from 'vue-quill-editor'
  import Panel from '@/components/template/Panel'
  import ProductPrice from '@/components/shared/ProductPrice'
  import FormGroup from '@/components/template/FormGroup'
  import Gallery from 'vue-gallery/src/component/gallery'
  import SimpleListLog from '@/components/shared/SimpleListLog'
  import ModalPriceHistory from '@/components/marketplace/shared/ModalPriceHistory'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data: () => ({
      galleryIndex: null,
      logFilters: {
        identifier: null,
        module_identifier: null,
        page: 1,
        limit: 5
      },
      modalPriceHistory: false
    }),
    props: {
      product: {
        type: Object,
        required: true,
        warranty: null
      },
      images: {
        type: Array,
        default: [],
        required: false
      }
    },
    created () {
      this.logFilters.identifier = this.product.sku
      this.logFilters.module_identifier = this.$router.history.current.path.split('/')[2]
      if (this.logFilters.module_identifier === 'zoom') {
        try {
          var voltageAttribute = this.product.attributes.find(atribute => atribute.id === 'voltage')
          this.product.attributes['voltage'] = voltageAttribute.valueId
        } catch (err) {
          this.product.attributes['voltage'] = 'none'
        }
      }
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      formatProduct () {
        const formattedProduct = this.$parent.formatProduct()

        if (this.logFilters.module_identifier === 'zoom') {
          formattedProduct['attributes'] = {
            voltage: this.product.attributes['voltage']
          }
        }

        switch (this.product.price.type) {
          case 'source':
            return {
              ...formattedProduct,
              sku: this.product.sku,
              price: {
                type: 'source',
                previous: this.product.price.previous,
                current: this.product.price.current
              },
              stock: {
                reducer: this.product.stock.reducer
              }
            }
          case 'custom':
            return {
              ...formattedProduct,
              sku: this.product.sku,
              price: {
                type: 'custom',
                previous: this.product.price.previous,
                current: this.product.price.current
              },
              stock: {
                reducer: this.product.stock.reducer
              }
            }
          case 'percent':
            return {
              ...formattedProduct,
              sku: this.product.sku,
              price: {
                type: 'percent',
                auxiliary: this.product.price.auxiliary
              },
              stock: {
                reducer: this.product.stock.reducer
              }
            }
          case 'fixedValue':
            return {
              ...formattedProduct,
              sku: this.product.sku,
              price: {
                type: 'fixedValue',
                auxiliary: this.product.price.auxiliary
              },
              stock: {
                reducer: this.product.stock.reducer
              }
            }
        }
      },
      showPriceHistory () {
        this.modalPriceHistory = !this.modalPriceHistory
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError',
        'getErrors'
      ]),
      productStatusMessage () {
        return `<strong>${this.$t('product.label')}:</strong> ${this.product.message.replace('\n', '<br>- ')}`
      },
      productStockStatusMessage () {
        return `<strong>${this.$t('stock.label')}:</strong> ${this.product.stock.message.replace('\n', '<br>- ')}`
      },
      productPriceStatusMessage () {
        return `<strong>${this.$t('price.label')}:</strong> ${this.product.price.message.replace('\n', '<br>- ')}`
      }
    },
    components: {
      ModalPriceHistory,
      Gallery,
      Panel,
      ProductPrice,
      FormGroup,
      SimpleListLog,
      quillEditor
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-bottom: 10px

  .image-container
    display: inline-block
    border: 1px solid #333
    padding: 0 10px
    cursor: zoom-in

    &:not(:first-child)
      margin-left: 16px
      margin-bottom: 16px

    img
      max-width: 80px

  .c-note
    margin-bottom: 16px

  .btn-history
    margin-right: 10px

    i
      margin-right: 5px
</style>



// WEBPACK FOOTER //
// ProductEdit.vue?6d4ded0b